import http from "./http"; // 导入配置好的axios文件
import Vue from 'vue'
import { Message } from 'element-ui';
// Vue.use(Message)

// 封装axios请求函数，并用export导出
export function postForm(url, datas) {
  return http({
    url: url,
    method: "post",
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式
      "orgNo": "lingke", //固定值
      //"token": localStorage.getItem("token")  //token
    },
    data: datas
  }).catch(error => {
    console.error("method:postForm,url:" + url, error);
  });
}
export function getForm(url, datas) {
  return http({
    url: url,
    method: "get",
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式
      "orgNo": "lingke", //固定值
      //"token": localStorage.getItem("token")  //token
    },
    params: datas
  }).catch(error => {
    console.error("method:postForm,url:" + url, error);
  });
}
//提示
export function tips(text) {
  Message({ message: text });
}
/////////////////////////////////////////接口
// export function getqueryFieldList(datas) {
//   return getForm("/api/jnField/queryFieldList", datas);
// }

export function getqueryProductList() {
  return getForm("/api/jnProducts/queryProductList");
}

export function getqueryProductDeatil(datas) {
  return getForm("/api/jnProducts/queryProductById", datas);
}

export function getqueryNewsPage(datas) {
  return getForm("/api/jnNews/queryNewsPage", datas);
}

export function getqueryNewsById(datas) {
  return getForm("/api/jnNews/queryNewsById", datas);
}

export function getqueryTechnologyList(datas) {
  return getForm("/api/jnCoreTechnology/queryTechnologyList", datas);
}

export function getqueryTechnologyDataList(datas) {
  return getForm("/api/jnTechnologyData/queryTechnologyDataList", datas);
}

export function getqueryQualityAssuranceList(datas) {
  return getForm("/api/jnQualityAssurance/queryQualityAssuranceList", datas);
}

export function getqueryEmployInfoList(datas) {
  return getForm("/api/jnEmployInfo/queryEmployInfoList", datas);
}

export function getaboutUs(datas) {
  return getForm("/api/jnPageModel/aboutUs", datas);
}

export function getqueryNavigationList(datas) {
  return getForm("/api/jnNavigationInfo/queryNavigationList", datas);
}

export function getqueryBannerList(datas) {
  return getForm("/api/jnBanner/queryBannerList", datas);
}

export function getqueryFieldList(datas) {
  return getForm("/api/jnField/queryFieldList", datas);
}

export function getqueryNewsListForIndex(datas) {
  return getForm("/api/jnNews/queryNewsListForIndex", datas);
}

export function getjnFeedbackInfo(datas) {
  return postForm("/api/jnFeedbackInfo", datas);
}

export function getqueryStaffPhotoList(datas) {
  return getForm("/api/jnStaffPhoto/queryStaffPhotoList", datas);
}
export function getqueryWelfareList(datas) {
  return getForm("/api/welfareInfo/queryWelfareList", datas);
}
export function getqueryProcessList(datas) {
  return getForm("/api/productionProcess/queryProcessList", datas);
}

export function getqueryCultureList(datas) {
  return getForm("/api/corporateCulture/queryCultureList", datas);
}
export function getqueryHistoryList(datas) {
  return getForm("/api/historyInfo/queryHistoryList", datas);
}



// WEBPACK FOOTER //
// ./src/config/api.js